import { Storage, StorageType } from './storage-adapter.service';

export const storageAdapterMock: { get(type: StorageType): Storage } = {
  get: (type: StorageType): Storage => {
    switch (type) {
      case StorageType.PERSISTENT:
        return persistentMock;
      case StorageType.SESSION:
        return sessionMock;
      case StorageType.MEMORY:
        return memoryMock;
      default:
        throw new Error('Unsupported storage type (mock)');
    }
  },
};

const persistentStore = new Map<string, string>();
const sessionStore = new Map<string, string>();
const memoryStore = new Map<string, string>();

const persistentMock: Storage = {
  getValue: async <T>(key: string) => {
    const raw = persistentStore.get(key) || null;
    return raw ? (JSON.parse(raw) as T) : null;
  },
  setValue: async <T>(key: string, value: T) => {
    persistentStore.set(key, JSON.stringify(value));
  },
  removeValue: async (key: string) => {
    persistentStore.delete(key);
  },
};

const sessionMock: Storage = {
  getValue: async <T>(key: string) => {
    const raw = sessionStore.get(key) || null;
    return raw ? (JSON.parse(raw) as T) : null;
  },
  setValue: async <T>(key: string, value: T) => {
    sessionStore.set(key, JSON.stringify(value));
  },
  removeValue: async (key: string) => {
    sessionStore.delete(key);
  },
};

const memoryMock: Storage = {
  getValue: async <T>(key: string) => {
    const raw = memoryStore.get(key) || null;
    return raw ? (JSON.parse(raw) as T) : null;
  },
  setValue: async <T>(key: string, value: T) => {
    memoryStore.set(key, JSON.stringify(value));
  },
  removeValue: async (key: string) => {
    memoryStore.delete(key);
  },
};
